import React from "react";
import PropTypes from "prop-types";
import { Button } from "../../ui/Button/index.js"
import { useTranslation } from "react-i18next";

/**
 * ProductActions Molecule - Action buttons for product (View Gift, etc.)
 * @component
 * @example
 * <ProductActions
 *   onViewGift={() => console.log('view')}
 *   showRevisitMemory={true}
 *   onRevisitMemory={() => console.log('revisit')}
 * />
 */
const ProductActions = ({
    onViewGift,
    onAddToCart,
    onBuyNow,
    showRevisitMemory = false,
    onRevisitMemory,
    className = "",
    fullWidth = true,
    isSpecial = false,
    addToCartText,
    buyNowText,
    isSelected = false,
}) => {
    const { t } = useTranslation();
    return (
        <div className={`flex flex-col gap-3 w-full ${className}`}>
            {showRevisitMemory && (
                <Button
                    variant="outline"
                    size="md"
                    rounded="full"
                    className="text-orange-400 bg-grey-500 border-orange-400 hover:bg-orange-400 hover:text-red-50 w-full h-11"
                    onClick={onRevisitMemory}
                >
                    {t("eventsAndSpaces.revisitMemory")}
                </Button>
            )}

            {/* <Button
                variant="primary"
                size="md"
                rounded="full"
                onClick={onViewGift}
                className="w-full h-12 text-sm font-bold"
            >
                {t("eventsAndSpaces.viewGift")}
            </Button> */}

            {/* <Button
                variant={isSpecial ? "custom" : "primary"}
                size="md"
                rounded="full"
                onClick={onAddToCart}
                className={`w-full h-12 text-sm font-bold shadow-md ${isSpecial
                    ? "bg-white text-red-500 hover:bg-neutral-50 border-none"
                    : isSelected
                        ? "bg-red-600 border-red-600 text-white cursor-default"
                        : "shadow-red-50"
                    }`}
            >
                {addToCartText || t("cart.addToCart") || "Add to Cart"}
            </Button> */}

            {/* <Button
                variant={isSpecial ? "custom" : "primary"}
                size="md"
                rounded="full"
                onClick={onBuyNow}
                className={`w-full h-12 text-sm font-bold shadow-md ${isSpecial
                    ? "bg-white text-red-500 hover:bg-neutral-50 border-none"
                    : "shadow-red-100"
                    }`}
            >
                {t("cart.buyNow") || "Buy Now"}
            </Button> */}
        </div>
    );
};

ProductActions.propTypes = {
    onViewGift: PropTypes.func.isRequired,
    showRevisitMemory: PropTypes.bool,
    onRevisitMemory: PropTypes.func,
    className: PropTypes.string,
    isSpecial: PropTypes.bool,
    isSelected: PropTypes.bool,
};

export default ProductActions;
